export const getCharacterLimitByAdWriterRadioValue = (value: string) => {
  switch (value) {
    case 'headline':
      return '30';
    case 'description':
      return '90';
    default:
      return '';
  }
};
